
// ###################################################################

import React, { useState, useEffect } from "react";

import WorkspaceService from "services/workspace-service";


import DowngradeAlert from "layouts/components/Downgrade";

const RequireSubscriptionUsage = ({
  hasActiveSubscription,
  hasOwnProfiles,
  initialLoadComplete,
  children,
}) => {

  const [isUsageCompliant, setIsUsageCompliant] = useState(null);

  const [usageData, setUsageData] = useState({
    profilesUsed: 0,
    snapshotsUsed: 0,
    profilesLimit: 0,
    snapshotsLimit: 0,
    reportsUsed: 0, // [NEW]
    reportsLimit: 0, // [NEW]
  });

  // ⭐ MOVE THIS OUTSIDE useEffect so DowngradeAlert can call it
  const checkUsageLimits = async () => {
    try {
      // ⭐ Fetch Entitlements (includes usage + usage limits + boosts)
      const entitlements = await WorkspaceService.fetchWorkspaceEntitlements();

      if (!entitlements || !entitlements.limits || !entitlements.usage) {
        console.warn("Entitlements data missing — skipping downgrade check.");
        setIsUsageCompliant(true);
        return;
      }

      // 1. Get Limits (Base + Boosts are already calculated in backend response)
      const profilesLimit = entitlements.limits.profiles || 0;
      const snapshotsLimit = entitlements.limits.snapshots || 0;
      const reportsLimit = entitlements.limits.reports || 0; // [NEW]

      // 2. Get Usage (Includes active_snapshots and active_reports)
      const profilesUsed = entitlements.usage.profiles || 0;
      const snapshotsUsed = entitlements.usage.active_snapshots || 0;
      const reportsUsed = entitlements.usage.active_reports || 0; // [NEW]

      const isOverProfiles = profilesUsed > profilesLimit;
      const isOverSnapshots = snapshotsUsed > snapshotsLimit;
      const isOverReports = reportsUsed > reportsLimit; // [NEW]

      const overLimit = isOverProfiles || isOverSnapshots || isOverReports;

      // ⭐ Update shared usage data
      setUsageData({
        profilesUsed,
        snapshotsUsed,
        profilesLimit,
        snapshotsLimit,
        reportsUsed, // [NEW]
        reportsLimit, // [NEW]
      });

      setIsUsageCompliant(!overLimit);

    } catch (err) {
      console.error("Error during usage limit check:", err);
      setIsUsageCompliant(true);
    }
  };

  // Run on page load
  useEffect(() => {
    if (hasActiveSubscription === true && hasOwnProfiles === true) {
      checkUsageLimits();
    }
  }, [hasActiveSubscription, hasOwnProfiles]);

  if (
    (hasActiveSubscription !== true ||
      hasOwnProfiles !== true ||
      isUsageCompliant === null) && !initialLoadComplete
  ) {
    return null;
  }

  return (
    <>
      {children}

      {isUsageCompliant === false && (
        <DowngradeAlert
          open={true}
          onClose={() => { }}
          profilesUsed={usageData.profilesUsed}
          profilesLimit={usageData.profilesLimit}
          snapshotsUsed={usageData.snapshotsUsed}
          snapshotsLimit={usageData.snapshotsLimit}
          reportsUsed={usageData.reportsUsed} // [NEW]
          reportsLimit={usageData.reportsLimit} // [NEW]
          onUsageChanged={checkUsageLimits}   // ⭐ REQUIRED
        />
      )}
    </>
  );
};

export default RequireSubscriptionUsage;
